import axios from "axios";
import ApiService from "./api.service";
import {
  TokenService,
  TokenServiceApp,
  UserDetail,
  LocationId,
  UserIdService
} from "./storage.service";

// const KHAANPIN_USER = '';
class AuthenticationError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const UserService = {
  /**
   * Login the user and store the access token to TokenService.
   *
   * @returns token
   * @throws AuthenticationError
   **/
  megamenu: async function(location_id) {
    const data = {
      loc_id: location_id,
    };
    try {
      const response = await axios.post(
        "https://deus.khaanpin.com/appapi/menulist/",
        data
      );
      // console.log(response, "megamemu response from userservice");
      // console.log(response.data, "hello this is response from user.service");
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },

  login: async function(email, password) {
    const requestData = {
      method: "post",
      url: `${process.env.VUE_APP_ROOT_API}/login/`,
      data: {
        username: email,
        password: password,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);

      console.log(response, "response login")

      TokenService.saveToken(response.data.token);
      // TokenService.saveRefreshToken(response.data.refresh_token);
      ApiService.setHeader();

      // NOTE: We haven't covered this yet in our ApiService
      //       but don't worry about this just yet - I'll come back to it later
      // ApiService.mount401Interceptor();
      // console.log(response, "user.service.js response")
      return response.data;
    } catch (error) {
      throw new AuthenticationError(
        error.response.status,
        error.response.data.detail
      );
    }
  },

  socialLogin: async function(sm_id, sm_name) {
    // console.log(sm_id, sm_name, "user service");
    const requestData = {
      method: "post",
      url: `${process.env.VUE_APP_ROOT_API}/loginbyid/`,
      data: {
        sm_id: sm_id,
        sm_name: sm_name,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      // console.log("socialLogin here",response.data.data)
      // console.log(response, "response userservice")
      // console.log(response.data.data, "response data");

      TokenServiceApp.saveToken(response.data.data.token);
      ApiService.setHeaderApp();

      return response.data;
    } catch (error) {
      throw new AuthenticationError(
        error.response.status,
        error.response.data.detail
      );
    }
  },

  /**
   * User Register Api call
   */
  register: async function(
    username,
    first_name,
    last_name,
    phone,
    otp,
    email,
    password,
    address
  ) {
    const requestData = {
      method: "post",
      url: `${process.env.VUE_APP_ROOT_API}/register/`,
      data: {
        username,
        first_name,
        last_name,
        phone,
        otp,
        email,
        password,
        address,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);

      return response.data;
    } catch (error) {
      return error;
    }
  },

  socialRegister: async function(
    first_name,
    last_name,
    email,
    username,
    password,
    registration_source,
    sm_name,
    sm_id
  ) {
    const requestData = {
      method: "post",
      url: `${process.env.VUE_APP_ROOT_API}/register/`,
      data: {
        first_name,
        last_name,
        email,
        username,
        password,
        registration_source,
        sm_name,
        sm_id,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);

      return response.data;
    } catch (error) {
      return error;
    }
  },

  /**
   * OTP Send
   */
  otpSend: async function(phone) {
    const requestData = {
      method: "post",
      url: `${process.env.VUE_APP_ROOT_API}/sendotp/`,
      data: {
        number: phone,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      return response.data;
    } catch (error) {
      return error;
    }
  },

  /**
   * PRomo Send
   */
  promoSend: async function(promo) {
    const requestData = {
      method: "post",
      // url: `https://manager.khaanpin.com/api/getcoupen/`,
      url: `https://deus.khaanpin.com/om/getcoupen/`,

      data: {
        code: promo,
        loc_id: LocationId.getLocationId(),
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      return response.data;
    } catch (error) {
      return error;
    }
  },

  /**
   * User Detail call n send info
   */
  userinfo: async function(token) {
    
    const requestData = {
      method: "get",
      // url: `https://manager.khaanpin.com/apiv2/getuserdetails/`,
      url: `https://deus.khaanpin.com/appapi/getuserdetails/`,

      headers: {
      
        Authorization: `Token ${token}`,
      
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      UserDetail.setLoggedUser(response.data.data);
      return response.data.data;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  },

  /**
   * User Detail Update
   */
  userupdate: async function(username, first_name, last_name, phone, address) {
    const requestData = {
      method: "patch",
      url: `${process.env.VUE_APP_ROOT_API}/updateuserdetails/2`,
      data: {
        username,
        first_name,
        last_name,
        phone,
        address,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      UserDetail.setLoggedUser(response.data.data);
      return response.data;
    } catch (error) {
      return error;
    }
  },

  /**
   * Logout the current user by removing the token from storage.
   *
   * Will also remove `Authorization Bearer <token>` header from future requests.
   **/
  logout() {
    // Remove the token and remove Authorization header from Api Service as well
    TokenService.removeToken();
    TokenServiceApp.removeToken();
    // UserIdService.removeUserId();
    // localStorage.removeItem("user_id");

    // localStorage.removeItem("KHAANPIN_USER");
    // localStorage.removeItem("CART_CONTENT");
    // localStorage.removeItem("CART_TOTAL");
    // TokenService.removeRefreshToken();

    localStorage.clear();
    ApiService.removeHeader();

    // NOTE: Again, we'll cover the 401 Interceptor a bit later.
    // ApiService.unmount401Interceptor();
  },
};

const GetUserCarts = {
  getItems: async function() {
    let url = `${process.env.VUE_APP_ROOT_API}/getmycarts/`;
    try {
      ApiService.setHeader();
      // ApiService.setHeaderApp();
      const response = await ApiService.get(url);
      // console.log(response, "get user cart");
      return response.data;
    } catch (error) {
      return error;
    }
  },

  getItemSocial: async function() {
    let url = `${process.env.VUE_APP_ROOT_API}/getmycarts/`;
    try {
      // ApiService.setHeader();
      ApiService.setHeaderApp();
      const response = await ApiService.get(url);
      // console.log(response, "get user cart");
      return response.data;
    } catch (error) {
      return error;
    }
  },
};

const ForgotPasswordEmail = {
  checkPassword: async function(email) {
    const requestData = {
      method: "post",
      url: `${process.env.VUE_APP_ROOT_API}/sendpwdtoemail/`,
      data: {
        email,
      },
    };
    try {
      // ApiService.setHeader();
      const response = await ApiService.customRequest(requestData);

      return response.data;
    } catch (error) {
      return error;
    }
  },
};

export default UserService;

export { UserService, AuthenticationError, GetUserCarts, ForgotPasswordEmail };
